import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
import classNames from "classnames";
import { clone, get, isEmpty } from "lodash";
import React, { useContext, useRef, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { PatientsContext } from "../../components/Patients/PatientsContext";
import WorklistHeader from "../../components/Worklist/WorklistHeader";
import QuickAccessFilters from "../../components/Worklist/QuickAccessFilters";
import PullToRefresh from "react-simple-pull-to-refresh";
import { faLoader } from "@fortawesome/pro-regular-svg-icons";
import constants from "../../utils/constants";
import { faArrowDown } from "@fortawesome/pro-regular-svg-icons";
import { faSortUp } from "@fortawesome/pro-duotone-svg-icons";
import AwesomeIcon from "../../components/AwesomeIcon";
import BulkPatientCard from "./BulkPatientCard";
import WorklistLoader from "../../components/Worklist/WorklistLoader";
import CustomCheckbox from "./CustomCheckbox";
import { trackEvent } from "../../utils/mixpanel";
import { MIXPANEL_EVENTS } from "../../utils/mixpanelEvents";
import BulkAssignBar from "./BulkAssignBar";
import useBulkTaggingService from "./services/bulkTaggingService";
import Toast from "../../components/Toast";
import useWorkspaceTagSettingsService from "../../components/CustomTagsManagement/services/workspaceTagSettingsService";
import { useApplySavedFilterAction } from "../../components/Assistant/utils/actions/useApplyFilterAction";
import { useIsBulkTaggingEnabled } from "../../components/Assistant/utils/actions/useAddBulkTagging";
import DicomUpload from "../../components/DicomUpload";
import SortControl, { SORT_BY_MAP, SORT_ORDER_MAP } from "../../components/Worklist/SortControl";
import { requestWorklistFilterChange } from "../../utils/worklistFilterNavigation";
import { Authenticated, useAuth } from "@qure/qure-auth";
export default function BulkActions() {
  var _filters$data, _userWorkspaces$find;
  var _useState = useState(false),
    showFilters = _useState[0],
    setShowFilters = _useState[1];
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var scrollPositionRef = useRef(0);
  var worklistContainerRef = useRef(null);
  var _useContext = useContext(PatientsContext),
    patientsData = _useContext.patientsData,
    setLastId = _useContext.setLastId,
    setPatientsData = _useContext.setPatientsData,
    filters = _useContext.filters,
    setFilters = _useContext.setFilters,
    lastId = _useContext.lastId,
    isPatientsLoading = _useContext.isPatientsLoading,
    savedFilterData = _useContext.savedFilterData,
    setSavedFilterData = _useContext.setSavedFilterData,
    count = _useContext.count,
    selectedWorkspace = _useContext.selectedWorkspace,
    sortParams = _useContext.sortParams,
    setSortParams = _useContext.setSortParams,
    userWorkspaces = _useContext.userWorkspaces,
    refetchUserWorkspace = _useContext.refetchUserWorkspace,
    savedFilters = _useContext.savedFilters;
  var _useAuth = useAuth(),
    userInfo = _useAuth.userInfo;
  var _ref = useWorkspaceTagSettingsService(selectedWorkspace === null || selectedWorkspace === void 0 ? void 0 : selectedWorkspace.value),
    customFields = _ref.data;
  var bulkTaggingMutation = useBulkTaggingService(userInfo === null || userInfo === void 0 ? void 0 : userInfo.default_workspace);
  var _useState2 = useState(false),
    isUpdating = _useState2[0],
    setIsUpdating = _useState2[1];
  var patients = get(patientsData, ["data", "content"], []);
  var pageLength = get(patientsData, ["data", "page_size"], 0);
  var pageSize = get(patientsData, ["data", "page_size"], 0);
  // Show loading only for initial loads (when lastId is empty), not during pagination
  // This ensures: (1) initial load shows full loader, (2) pagination shows existing list + loader at bottom
  var isLoading = !lastId && (isPatientsLoading || patientsData === null);
  var _useState3 = useState(new Set()),
    selectedPatients = _useState3[0],
    setSelectedPatients = _useState3[1];
  var _useState4 = useState(""),
    selectedAssignee = _useState4[0],
    setSelectedAssignee = _useState4[1];
  var selectAllRef = useRef(null);
  var isLC = process.env.NEXT_PUBLIC_IS_LC === "true";

  // Get custom fields that should be shown as columns (grouped by sections)
  var getWorklistSections = function getWorklistSections() {
    var sectionMap = new Map();

    // Group fields by section
    customFields === null || customFields === void 0 || customFields.forEach(function (field) {
      if (field.additional.isAddToWorklistAsColumn) {
        var _field$properties;
        var section = ((_field$properties = field.properties) === null || _field$properties === void 0 ? void 0 : _field$properties.section) || "";
        var sectionKey = section.toLowerCase();
        if (!sectionMap.has(sectionKey)) {
          sectionMap.set(sectionKey, []);
        }
        sectionMap.get(sectionKey).push(field);
      }
    });

    // Convert to array and sort alphabetically
    return Array.from(sectionMap.entries()).map(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
        sectionKey = _ref3[0],
        fields = _ref3[1];
      return {
        section: sectionKey.charAt(0).toUpperCase() + sectionKey.slice(1),
        fields: fields
      };
    }).sort(function (a, b) {
      return a.section.localeCompare(b.section);
    }).filter(function (sectionData) {
      return sectionData.fields.length > 0;
    });
  };
  var worklistSections = getWorklistSections();

  // Calculate grid columns based on sections
  var gridTemplateColumns = "50px 1fr 1fr 1.2fr ".concat(worklistSections === null || worklistSections === void 0 ? void 0 : worklistSections.map(function () {
    return "1fr";
  }).join(" "));
  var gridStyle = {
    display: "grid",
    gridTemplateColumns: gridTemplateColumns,
    columnGap: "1rem"
  };
  useApplySavedFilterAction(setFilters, setSavedFilterData, filters === null || filters === void 0 || (_filters$data = filters.data) === null || _filters$data === void 0 ? void 0 : _filters$data.label, patients, function () {}, count, isLoading);
  useIsBulkTaggingEnabled(selectedPatients);
  useEffect(function () {
    if (selectAllRef.current) {
      selectAllRef.current.indeterminate = selectedPatients.size > 0 && selectedPatients.size < patients.length;
    }
  }, [selectedPatients, patients.length]);
  var getNextPage = function getNextPage() {
    if (patients.length && pageLength >= pageSize) {
      var lastPatientUid = get(patients, [patients.length - 1, "patient_uid"], 0);
      setLastId(lastPatientUid);
    }
  };
  var onScrollWorklist = function onScrollWorklist(e) {
    var element = e.currentTarget;
    if (element.scrollHeight - element.scrollTop - element.clientHeight <= 10) {
      getNextPage();
    }
    scrollPositionRef.current = element === null || element === void 0 ? void 0 : element.scrollTop;
  };
  var scrollToTop = function scrollToTop() {
    var _worklistContainerRef;
    (_worklistContainerRef = worklistContainerRef.current) === null || _worklistContainerRef === void 0 || _worklistContainerRef.scrollTo(0, 0);
  };
  var onWorklistRefresh = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            setPatientsData(null);
            if (!lastId) {
              _context.n = 2;
              break;
            }
            _context.n = 1;
            return setLastId("");
          case 1:
            _context.n = 3;
            break;
          case 2:
            _context.n = 3;
            return setFilters(clone(filters));
          case 3:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function onWorklistRefresh() {
      return _ref4.apply(this, arguments);
    };
  }();
  var handleSelect = function handleSelect(patient) {
    setSelectedPatients(function (prev) {
      var newSet = new Set(prev);
      var uid = String(patient.patient_uid);
      if (newSet.has(uid)) {
        newSet["delete"](uid);
      } else {
        newSet.add(uid);
      }
      return newSet;
    });
  };
  var handleSelectAll = function handleSelectAll() {
    if (selectedPatients.size === patients.length) {
      setSelectedPatients(new Set());
    } else {
      setSelectedPatients(new Set(patients.map(function (p) {
        return String(p.patient_uid);
      })));
    }
  };
  var handleTimestampTypeChange = function handleTimestampTypeChange(type) {
    requestWorklistFilterChange(function () {
      scrollToTop();
      setSortParams(_objectSpread(_objectSpread({}, sortParams), {}, {
        orderBy: type
      }));
      setLastId("");
    });
  };
  var isTaskDueSortActive = sortParams.orderBy === SORT_BY_MAP.reminder && sortParams.order === SORT_ORDER_MAP.asc;
  var handleTaskDueSortClick = function handleTaskDueSortClick() {
    if (isTaskDueSortActive) {
      requestWorklistFilterChange(function () {
        scrollToTop();
        setSortParams(_objectSpread(_objectSpread({}, sortParams), {}, {
          orderBy: SORT_BY_MAP.created_at,
          order: SORT_ORDER_MAP.desc
        }));
        setLastId("");
        trackEvent(MIXPANEL_EVENTS.WORKLIST_SORT_TYPE_CHANGED, {
          label: SORT_BY_MAP.created_at,
          source: "task_due_column_header_cleared"
        });
      });
    } else {
      requestWorklistFilterChange(function () {
        scrollToTop();
        setSortParams(_objectSpread(_objectSpread({}, sortParams), {}, {
          orderBy: SORT_BY_MAP.reminder,
          order: SORT_ORDER_MAP.asc
        }));
        setLastId("");
        trackEvent(MIXPANEL_EVENTS.WORKLIST_SORT_TYPE_CHANGED, {
          label: SORT_BY_MAP.reminder,
          source: "task_due_column_header"
        });
      });
    }
  };
  var handleSortOrderChange = function handleSortOrderChange(order) {
    requestWorklistFilterChange(function () {
      scrollToTop();
      setSortParams(_objectSpread(_objectSpread({}, sortParams), {}, {
        order: order
      }));
      setLastId("");
    });
  };
  var handleAssign = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(assignField) {
      var patientIds, _t;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            if (assignField) {
              _context2.n = 1;
              break;
            }
            return _context2.a(2);
          case 1:
            _context2.p = 1;
            if (!isUpdating) {
              _context2.n = 2;
              break;
            }
            return _context2.a(2);
          case 2:
            setIsUpdating(true);
            patientIds = Array.from(selectedPatients).map(Number);
            _context2.n = 3;
            return bulkTaggingMutation.mutateAsync({
              patient_ids: patientIds,
              custom_tags: [{
                tag_id: Number(assignField.id),
                response: selectedAssignee
              }]
            });
          case 3:
            Toast.success(t("Bulk assignment in progress!!"), {
              autoClose: 3000
            });
            refetchUserWorkspace();
            _context2.n = 5;
            break;
          case 4:
            _context2.p = 4;
            _t = _context2.v;
            Toast.error(t("Bulk assignment failed"), {
              autoClose: 3000
            });
          case 5:
            _context2.p = 5;
            setIsUpdating(false);
            return _context2.f(5);
          case 6:
            return _context2.a(2);
        }
      }, _callee2, null, [[1, 4, 5, 6]]);
    }));
    return function handleAssign(_x) {
      return _ref5.apply(this, arguments);
    };
  }();
  var handleUpdateFields = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(fields) {
      var patientIds, _t2;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.p = _context3.n) {
          case 0:
            if (!isUpdating) {
              _context3.n = 1;
              break;
            }
            return _context3.a(2);
          case 1:
            setIsUpdating(true);
            _context3.p = 2;
            patientIds = Array.from(selectedPatients).map(Number);
            _context3.n = 3;
            return bulkTaggingMutation.mutateAsync({
              patient_ids: patientIds,
              custom_tags: fields.map(function (f) {
                return {
                  tag_id: Number(f.field.id),
                  response: f.value
                };
              })
            });
          case 3:
            Toast.success(t("Bulk tagging in progress!"), {
              autoClose: 3000
            });
            // Trigger workspace data refetch
            refetchUserWorkspace();
            _context3.n = 5;
            break;
          case 4:
            _context3.p = 4;
            _t2 = _context3.v;
            Toast.error(t("Bulk tagging failed"), {
              autoClose: 3000
            });
          case 5:
            _context3.p = 5;
            setIsUpdating(false);
            return _context3.f(5);
          case 6:
            return _context3.a(2);
        }
      }, _callee3, null, [[2, 4, 5, 6]]);
    }));
    return function handleUpdateFields(_x2) {
      return _ref6.apply(this, arguments);
    };
  }();
  var onSearch = function onSearch(value) {
    var searchValue = value || "";
    setLastId("");
    // Use the functional updater so we always build on the latest applied state.
    // This keeps an active filter (incl. an auto-applied default in selectedFilters)
    // working alongside the search, while a cleared state stays independent.
    setFilters(function (prevFilters) {
      var hasActiveFilter = !!(prevFilters !== null && prevFilters !== void 0 && prevFilters.label) || Array.isArray(prevFilters === null || prevFilters === void 0 ? void 0 : prevFilters.selectedFilters) && prevFilters.selectedFilters.length > 0 || !!savedFilterData;
      return _objectSpread(_objectSpread({}, prevFilters), {}, {
        isFilterApplied: searchValue !== "" || hasActiveFilter,
        data: _objectSpread(_objectSpread({}, prevFilters === null || prevFilters === void 0 ? void 0 : prevFilters.data), {}, {
          search: searchValue
        })
      });
    });
  };
  return /*#__PURE__*/React.createElement(Authenticated, null, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col h-full bg-white dark:bg-gray-900"
  }, /*#__PURE__*/React.createElement(DicomUpload, null), /*#__PURE__*/React.createElement(WorklistHeader, {
    isFullWidthWorklist: true,
    setIsFullWidthWorklist: function setIsFullWidthWorklist() {},
    labelMappings: [],
    filters: filters,
    setFilters: setFilters,
    setLastId: setLastId,
    setPatientsData: setPatientsData,
    savedFilterData: savedFilterData,
    setSavedFilterData: setSavedFilterData,
    tagsList: [],
    patientsCount: count,
    isCountLoading: false,
    onSearch: onSearch,
    showFilters: showFilters,
    setShowFilters: setShowFilters,
    isMobile: false,
    onChange: function onChange() {},
    patients: patients.map(function (p) {
      var _p$patient_uid;
      return ((_p$patient_uid = p.patient_uid) === null || _p$patient_uid === void 0 ? void 0 : _p$patient_uid.toString()) || "";
    }),
    isLC: isLC,
    isLCWorklist: false,
    isLoading: isLoading,
    selectedWorkspace: selectedWorkspace,
    isBulkActions: true,
    savedFilters: savedFilters,
    scrollToTop: scrollToTop
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(QuickAccessFilters, {
    patientsCount: count,
    isCountLoading: false,
    patients: patients,
    filters: filters,
    setFilters: setFilters,
    setLastId: setLastId,
    setSavedFilterData: setSavedFilterData,
    isBulkActions: true,
    setPatientsData: setPatientsData,
    savedFilters: savedFilters
  })), selectedPatients.size > 0 && /*#__PURE__*/React.createElement(BulkAssignBar, {
    selectedCount: selectedPatients.size,
    customFields: customFields,
    selectedAssignee: selectedAssignee,
    onSelectAssignee: setSelectedAssignee,
    onAssign: handleAssign,
    onUpdateFields: handleUpdateFields,
    workspaceId: (userInfo === null || userInfo === void 0 ? void 0 : userInfo.default_workspace) || 0,
    selectedPatientIds: Array.from(selectedPatients).map(Number),
    isBulkTaggingInProgress: (userWorkspaces === null || userWorkspaces === void 0 || (_userWorkspaces$find = userWorkspaces.find(function (w) {
      return w.id === (selectedWorkspace === null || selectedWorkspace === void 0 ? void 0 : selectedWorkspace.value);
    })) === null || _userWorkspaces$find === void 0 ? void 0 : _userWorkspaces$find.bulk_tagging_status) === "inprogress",
    isUpdating: isUpdating
  }), /*#__PURE__*/React.createElement("div", {
    style: gridStyle,
    className: "px-5 py-2 bg-gray-200 dark:bg-gray-800 text-gray-800 dark:text-white/50 uppercase text-md font-semibold animate-fullWorklist items-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center w-8"
  }, /*#__PURE__*/React.createElement(CustomCheckbox, {
    checked: patients.length > 0 && selectedPatients.size === patients.length,
    onChange: handleSelectAll,
    inputRef: selectAllRef
  })), /*#__PURE__*/React.createElement(SortControl, {
    isFullWidthWorklist: true,
    sortControlActive: !isTaskDueSortActive,
    selectedType: sortParams.orderBy,
    onTypeChange: handleTimestampTypeChange,
    sortOrder: sortParams.order,
    onSortChange: handleSortOrderChange,
    onSortParamsChange: function onSortParamsChange(params) {
      requestWorklistFilterChange(function () {
        scrollToTop();
        setSortParams(params);
        setLastId("");
      });
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-2"
  }, /*#__PURE__*/React.createElement("span", null, t("label.task_due")), /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: function onClick(e) {
      e.preventDefault();
      e.stopPropagation();
      handleTaskDueSortClick();
    },
    className: classNames("p-0.5 rounded focus:outline-none focus-visible:ring-2 focus-visible:ring-teal-500", isTaskDueSortActive ? "text-teal-600 dark:text-teal-400 bg-gray-300/80 dark:bg-gray-600/80" : "text-gray-500 dark:text-gray-500 hover:bg-gray-300 dark:hover:bg-gray-700 hover:text-gray-700 dark:hover:text-gray-300"),
    "aria-pressed": isTaskDueSortActive,
    "aria-label": t("label.task_due")
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faSortUp,
    className: classNames("w-4 h-4", {
      "opacity-50": !isTaskDueSortActive
    })
  }))), /*#__PURE__*/React.createElement("div", null, t("label.task_details")), worklistSections === null || worklistSections === void 0 ? void 0 : worklistSections.map(function (section) {
    return /*#__PURE__*/React.createElement("div", {
      key: section.section,
      className: "text-gray-800 dark:text-white/50"
    }, section.section);
  })), /*#__PURE__*/React.createElement(PullToRefresh, {
    onRefresh: /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.n) {
          case 0:
            trackEvent(MIXPANEL_EVENTS.WORKLIST_REFRESHED);
            _context4.n = 1;
            return onWorklistRefresh();
          case 1:
            return _context4.a(2);
        }
      }, _callee4);
    })),
    refreshingContent: /*#__PURE__*/React.createElement(AwesomeIcon, {
      name: faLoader,
      className: "text-gray-900 dark:text-white animate-spin"
    }),
    resistance: constants.PULL_TO_REFRESH.resistance,
    maxPullDownDistance: constants.PULL_TO_REFRESH.maxPullDownDistance,
    pullingContent: /*#__PURE__*/React.createElement("div", {
      className: "text-gray-700 dark:text-gray-600 text-md text-center"
    }, /*#__PURE__*/React.createElement(AwesomeIcon, {
      name: faArrowDown,
      className: "mr-3"
    }), " ", t("pull_to_refresh"))
  }, /*#__PURE__*/React.createElement("div", {
    ref: worklistContainerRef,
    id: "worklist-container",
    className: "h-[calc(100vh-300px)] overflow-y-auto scrollbar-light dark:scrollbar overflow-x-hidden pb-8",
    onScroll: onScrollWorklist
  }, /*#__PURE__*/React.createElement("div", {
    role: "list",
    id: "worklist-cards",
    className: "flex flex-col w-full relative z-0 sm:divide-y divide-gray-200 sm:dark:divide-gray-800"
  }, isLoading ? /*#__PURE__*/React.createElement(WorklistLoader, null) : !isEmpty(patients) ? /*#__PURE__*/React.createElement(React.Fragment, null, patients === null || patients === void 0 ? void 0 : patients.map(function (patient, index) {
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: String(patient.patient_uid)
    }, /*#__PURE__*/React.createElement(BulkPatientCard, {
      patient: patient,
      selected: selectedPatients.has(String(patient.patient_uid)),
      onSelect: handleSelect,
      worklistColumns: worklistSections,
      gridStyle: gridStyle,
      timestampType: sortParams.orderBy,
      isLC: isLC
    }));
  })) : /*#__PURE__*/React.createElement("div", {
    className: "text-gray-500 dark:text-slate-500 text-lg h-full w-full flex items-center justify-center"
  }, t("no_patient_found")))))));
}